import React, { Component } from "react";
import { BiUserPlus, BiX, BiXCircle } from "react-icons/bi";
import { Popover, DropdownItem } from "reactstrap";
import axios from "../../axios";
import { isUserRemoved, profilePicValidityCheck, renderGenderPronoun } from "../../utils/constants";
import ReactTooltip from "react-tooltip";
import * as url from "../../utils/url";
import { connect } from "react-redux";

class AssigneeDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assigneeDropDownOpen: false,
      users: [],
    };

    this.timer = null;
  }

  handleAssignUser = (value) => {
    if (value && value.length > 0) {
      let res;
      axios.get(url.findUser(value)).then((resp, idx) => {
        let users = resp.data.data;
        // console.log('users--', users)
        if (users.length == 0) {
          users = "No users found";
        }
        res = {
          users,
        };
        this.setState({ ...res });
      });
    }
  };

  assignedUserDelay = (e) => {
    let value = e.target.value;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  handleSelectAssignee = (user) => {
    this.props.editTask("assignedTo");
    this.props.assignedUserFormat(user);
    this.setState({ assigneeDropDownOpen: false });
  };

  render() {
    const {
      task,
      currentUser,
      noMargin,
      taskAssignedUser,
      noEditable = false,
      textContainerStyle,
      helpText,
      forcetextPadding
    } = this.props;
    const { users } = this.state;
    return (
      <div className={noMargin ? "" : "assign-container-dropdown"}>
        <span id={"prio-1"} className="cursor-pointer">
          {task.assignedTo && task.assignedTo._id ? (
            <span
              className="assigned-user-circle"
              onClick={!noEditable && this.props.removeUser}
            >
              <span className="assignee-remove-icon">
                <BiXCircle size={"16px"} />
              </span>
              <span
                onClick={() => {
                  if (!noEditable) {
                    if (!users.length) {
                      this.handleAssignUser("a");
                    }
                    this.setState({
                      assigneeDropDownOpen: !this.state.assigneeDropDownOpen,
                    });
                  }
                }}
              >
                {taskAssignedUser &&
                currentUser &&
                currentUser._id.toString() === taskAssignedUser._id.toString()
                  ? ""
                  : isUserRemoved(task.assignedTo)
                  ? "Inactive User"
                  : null}
                {isUserRemoved(task.assignedTo) ? null : (
                  <span
                    data-tip={`${task.assignedTo.firstName} ${task.assignedTo.lastName}`}
                    style={{
                      display: "inline-flex",
                      flexDirection: "row",
                      marginTop: "7px",
                    }}
                  >
                    {profilePicValidityCheck(task.assignedTo.profilePic) ? (
                      <img
                        className="grp_create_search_user_pic"
                        src={task.assignedTo.profilePic}
                      />
                    ) : (
                      <span
                        className="spotlightUserInitials"
                        data-letters={this.getInitials(task.assignedTo)}
                      ></span>
                    )}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className={forcetextPadding?"pt-1":""}>
                        {" "}
                        {task.assignedTo.firstName} {task.assignedTo.lastName}{" "}
                        {currentUser && taskAssignedUser && currentUser._id.toString() ===
                          taskAssignedUser._id.toString() && "(You)"}
                      </div>

                      {renderGenderPronoun(task.assignedTo) ? (
                        <span className="user_gender_pronoun_planning_small pos_pln_sm_gp_align">
                          {renderGenderPronoun(task.assignedTo)}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </span>
                )}
              </span>
            </span>
          ) : (
            <span
              onClick={() => {
                if (!noEditable) {
                  if (!users.length) {
                    this.handleAssignUser("a");
                  }
                  this.setState({
                    assigneeDropDownOpen: !this.state.assigneeDropDownOpen,
                  });
                }
              }}
              style={{ ...textContainerStyle }}
            >
              <span
                className="cursor-pointer assign-border-wrapper"
                data-tip={helpText || "Assign to user"}
              >
                {" "}
                <BiUserPlus size={"24px"} />{" "}
              </span>
              <span className="assign-usr-txt planningOptions">{helpText}</span>
            </span>
          )}
        </span>
        <Popover
          isOpen={this.state.assigneeDropDownOpen}
          toggle={() =>
            this.setState({
              assigneeDropDownOpen: !this.state.assigneeDropDownOpen,
            })
          }
          container="inline"
          target={"prio-1"}
          hideArrow
          placement="bottom"
          className="p-3"
        >
          <label> {helpText || "Assign to user"}</label>
          <input
            type="text"
            id="invitedUsers"
            className="form-control"
            onChange={this.assignedUserDelay}
            autoComplete="off"
            placeholder="Search users.... "
          />

          <div
            className="divTableRow my-2 py-1"
            onClick={() => this.handleSelectAssignee(this.props.loggedInUser)}
          >
            <div className="px-2 cursor-pointer">
              {profilePicValidityCheck(this.props.loggedInUser.profilePic) ? (
                <img
                  className="grp_create_search_user_pic"
                  src={this.props.loggedInUser.profilePic}
                />
              ) : (
                <span
                  className="spotlightUserInitials"
                  data-letters={this.getInitials(this.props.loggedInUser)}
                ></span>
              )}
              Me
            </div>
          </div>

          {Array.isArray(users) && users.length > 0 ? (
            <div className="divTable w-100" style={{ position: "relative" }}>
              <div className="divTableBody assignee-dropdown-body">
                {users.map((user) => {
                  return (
                    <div
                      className="divTableRow"
                      onClick={() => this.handleSelectAssignee(user)}
                      key={user._id + user.organizationId}
                    >
                      <div className="px-2 cursor-pointer">
                        {profilePicValidityCheck(user.profilePic) ? (
                          <img
                            className="grp_create_search_user_pic"
                            src={user.profilePic}
                          />
                        ) : (
                          <span
                            className="spotlightUserInitials"
                            data-letters={this.getInitials(user)}
                          ></span>
                        )}
                        {user.firstName} {user.lastName}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.user.profile,
  };
};

export default connect(mapStateToProps, null)(AssigneeDropdown);
